export enum InvitationErrorCode {
    INVALID_EMAIL = 'client.invalid_email',
    TOO_LONG_EMAIL = 'client.too_long_email',
    API_EMAIL_WRONG_FORMAT = 'model.email.wrong_format.app_error',
    API_EMAIL_WRONG_LENGTH = 'model.email.wrong_length.app_error',
    API_INVALID_EMAIL = 'api.team.invite_members.invalid_email.app_error',
    API_INVALID_CURRENT_TEAM_EMAIL_DOMAIN = 'api.team.invite_members.invalid_team_domain.app_error',
    API_INVALID_WORKSPACE_TEAM_EMAIL_DOMAIN = 'api.team.invite_members.invalid_workspace_domain.app_error',
    API_INVALID_WORKSPACE_GUEST_EMAIL_DOMAIN = 'api.team.invite_members.invalid_guest_domain.app_error',
    API_ALLOWED_MEMBER_ROLE_ONLY = 'api.team.invite_members.member_role_only.app_error',
    API_ALLOWED_GUEST_ROLE_ONLY = 'api.team.invite_members.restricted_guest_role_only.app_error',
    API_ALLOWED_GUEST_PLUS_ROLE_ONLY = 'api.team.invite_members.guest_role_only.app_error',
    API_INVALID_TEAM_MEMBER ='api.team.invite_members.invalid_team_member.app_error',
    API_INVALID_GUEST = 'api.team.invite_guests.invalid_team_member.app_error',
    API_INVITATION_HAS_BEEN_SENT = 'api.invitation_has_been_sent',
    API_DEACTIVATED_MEMBER = 'api.team.invite_members.deactivate_team_member.app_error',
    API_DEACTIVATED_GUEST = 'api.team.invite_guests.deactivate_team_member.app_error',
    API_SENDING_ISSUE = 'api.team.invite_members.unable_to_send_email.app_error',
    API_LIMIT_EXCEEDED = 'app.email.rate_limit_exceeded.app_error',
    API_MEMBER_ALREADY_INVITED = 'api.team.invite_members.member_already_invited.app_error',
    API_GUEST_ALREADY_INVITED = 'api.team.invite_members.restricted_guest_already_invited.app_error',
    API_GUEST_PLUS_ALREADY_INVITED = 'api.team.invite_members.guest_already_invited.app_error',
    API_GUEST_TEAMS_LIMIT_EXCEEDED = 'api.team.add_restricted_guest.max_teams.app_error',
    API_UNAVAILABLE_WORKSPACE = 'api.team.invite_members.unavailable_workspace.app_error',
    API_SIGNUP_EMAIL_DISABLED = 'api.user.create_user.signup_email_disabled.app_error',
}
